import { SFCCBasket } from '../../models/sfcc-basket';
import { addLocaleToBasketUrl } from '../../utilities/add-locale-to-basket-url';
import { sfccSettings, shopHttp } from '../basket-api';

export const getBasket = async (basketId: string | number): Promise<SFCCBasket> => {
  const url = `/baskets/${basketId}`;
  const finalUrl = addLocaleToBasketUrl(url, sfccSettings.shopApiLocale);
  const response = await shopHttp.get<SFCCBasket>(finalUrl);

  return response.data;
};
